import api from "./client";

export async function startTrace() {
  const res = await api.post("/trace/start");
  return res.data;
}

export async function stopTrace() {
  const res = await api.post("/trace/stop");
  return res.data;
}

export async function getTraceStatus() {
  const res = await api.get("/trace/status");
  return res.data;
}
